import React, { useEffect, useState } from 'react';
import { notificationTypes } from '../../constants.js';
import { getDaysDiff, getPassedText } from '../helpers/HelperFunctions.js';

const NotificationItem = (props) => {    
    const [passedText, setPassedText] = useState('');

    useEffect(() => {
        updatePassesText();
    }, []);

    const updatePassesText = () => {
        const now = new Date();
        let date = new Date();

        const created = props.notification.created;
        if (created) {
            const [datePart, timePart] = created.split(' ');
            const [day, month, year] = datePart.split('.');
            const formattedString = `${year}-${month}-${day}T${timePart}:00`;

            date = new Date(formattedString);
        }

        const diff = getDaysDiff(date, now);
        setPassedText(getPassedText(diff));
    }

    const onNotificationClick = () => {
        if (props.onNotificationClick) {
            props.onNotificationClick(props.notification.id)
        }
    }

    return <div
        key={props.notification.id}
        id={props.notification.id}
        className={`notification ${props.notification.status === 'NEW' ? 'not-viewed' : ''} ${props.notification.type} ${props.notification.type === notificationTypes.stateChanged && props.notification.message.includes('Відхилено') ? notificationTypes.rejected : ''}`}
        onClick={onNotificationClick}
    >
        <div className='title'>{props.notification.title}</div>
        <div className='message'>{props.notification.message}</div>
        <div className='passed'>{passedText}</div>
    </div>
};

export default NotificationItem;